import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { takeStoredReturnTo, type SocialProvider, useSocialSignIn } from '../useSocialSignIn';

const PROVIDERS: SocialProvider[] = ['apple', 'facebook', 'google'];

// "#google_token=abc&state=x" → ['google', 'abc']. OauthApp URL-encodes the token, which URLSearchParams decodes.
const tokenFromHash = (hash: string): [SocialProvider, string] | null => {
  const params = new URLSearchParams(hash.replace(/^#/, ''));

  for (const provider of PROVIDERS) {
    const token = params.get(`${provider}_token`);
    if (token) return [provider, token];
  }
  return null;
};

// When the social sign-in popup can't report back, the sign-in app redirects to the starting page with the token in the hash
export const useSocialRedirectSignIn = () => {
  const history = useHistory();
  const { hash, pathname, search } = useLocation();
  const { signInWithToken } = useSocialSignIn();

  useEffect(() => {
    const providerToken = tokenFromHash(hash);
    if (!providerToken) return;

    // Keep the token out of the address bar and browser history
    history.replace({ hash: '', pathname, search });
    void signInWithToken(...providerToken, takeStoredReturnTo());
  }, [hash, history, pathname, search, signInWithToken]);
};
